/**
 *
 * @module productEntitlement
 *
 */

import Check from 'check-types';
import Exception from './../services/exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    nonEmptyString,
    number,
    object
} = Check.assert;

/**
 *
 * @class ProductEntitlement
 * @desc Represents the entitlements associated with a product a user is subscribed to.
 *
 */
export default class ProductEntitlement {

    /**
     *
     * @param {Object} options
     * @param {String} [options.desc=undefined]
     * @param {Number} options.id
     * @param {String} options.name
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'ProductEntitlement(options)',
            get options() {
                return `${this.ctor} options should be an Object`;
            },
            get id() {
                return `${this.ctor} id should be a Number`;
            },
            get name() {
                return `${this.ctor} name should be a String with length`;
            },
            get desc() {
                return `${this.ctor} desc should be a String with length`;
            }
        };

        object(options, errorMessage.options, InvalidArgumentException);

        const { desc, id, name } = options;

        number(id, errorMessage.id, InvalidArgumentException);
        nonEmptyString(name, errorMessage.name, InvalidArgumentException);

        if (Check.assigned(desc)) {
            nonEmptyString(desc, errorMessage.desc, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {String|undefined}
         * @desc The description of the product entitlement.
         *
         */
        this.description = desc;

        /**
         *
         * @access public
         * @type {Number}
         * @desc The id of the product entitlement.
         *
         */
        this.id = id;

        /**
         *
         * @access public
         * @type {String}
         * @desc The name of the product entitlement.
         *
         */
        this.name = name;

    }

}



// WEBPACK FOOTER //
// ./src/subscription/productEntitlement.js